export default {
	lightOrange: `#FF671F`,
	orange: `#FF5D00`,
	orange_RGB: `255, 93, 0`,
	lightGrey: `#F4F4F4`,
	grey: `#777777`,
	darkGrey: `#333333`,
}
